import { useEffect, useMemo, useState, useCallback } from 'react';
import { Field } from 'formik';
import NoCptWidget from './widgets/NoCptWidget';
import { GET_CPTS_COLUMNS, sortOptions } from './constants';
import QhsTable from '../../../../../../../Shared/Table/Table';
import CptEndCheckbox from './widgets/CptEndCheckbox';
import { useGenerateColumns, getSortedData } from '../../../../../../../Shared/Table/helpers';
import {
  TABLE_KEYS
} from '../../../../../../../../redux_store';

const Cpts = ({
                cpts,
                setCpts,
                loadingCptCodes,
                cptCodes,
                resetFiltersTrigger,
                setResetFiltersTrigger,
                updateFieldValue,
                values,
              }) => {
  const [filter, setFilter] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const getSortedAndFilteredData = (newFilters, newSort) =>
    getSortedData(
      cpts, //getFilteredData(cpts, newFilters, filterOptions),
      newSort,
      sortOptions,
    );

  useEffect(() => {
    setFilteredData(getSortedAndFilteredData(filter, []));
  }, [cpts]);

  useEffect(() => {
    if (resetFiltersTrigger) {
      const timeoutId = setTimeout(() => {
        setFilteredData(cpts);
        setFilter({});
        setResetFiltersTrigger(false);
      }, 300);
      return () => clearTimeout(timeoutId);
    }
  }, [resetFiltersTrigger, cpts, setResetFiltersTrigger]);
  const tableKey = TABLE_KEYS.cptsTable;

  const args = useMemo(
    () => {
      return {
        cptCodes: cptCodes,
        values: values,
        updateFieldValue: updateFieldValue,
      };
    },
    [cptCodes, updateFieldValue, values],
  );

  const columns = useGenerateColumns(GET_CPTS_COLUMNS, tableKey, { args }, {}).columns;

  const renderRowActions = useCallback(({ row: { index: index } }) => {
    return <Field type='text' name='ispConfiguration.services'>
      {({ form }) => (<CptEndCheckbox
          form={form}
          cpts={cpts}
          setCpts={setCpts}
          index={parseInt(index)}
        />
      )}
    </Field>;
  }, [cpts, setCpts]);

  if (!cpts?.length) {
    return <NoCptWidget />;
  }

  return <QhsTable
    columns={columns}
    data={filteredData || []}
    fetchNextPage={() => {}}
    isFetching={false}
    isLoading={loadingCptCodes}
    totalRowCount={filteredData.length}
    setData={setFilteredData}
    enableEditing={true}
    rowActionsTitleSize={40}
    renderRowActions={renderRowActions}
    tableKey={tableKey}
    removeVerticalCellPadding={true}
  />;
};

export default Cpts;
